/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Automation/view.blocks to change it.
import Event from './Event/index'
import EventActions from './EventActions/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Automation({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/ToggleLocationConnection/SetupAutomations/Content/Content/Content/Steps/Content/ActiveStep/Automation"
  
}) {
  return (<React.Fragment
>
<Event
  viewPath={`${viewPath}/Event`}
/>
<EventActions
  viewPath={`${viewPath}/EventActions`}
/>
{children}
</React.Fragment>)
}